import React, { useState, useEffect } from "react";
import "../styles/Auth.css";
import { Link } from "react-router-dom";

const Signup = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [darkMode, setDarkMode] = useState(false);

  useEffect(() => {
    setDarkMode(localStorage.getItem("darkMode") === "true");
  }, []);

  return (
    <div className={`auth-container ${darkMode ? "dark" : ""}`}>
      <div className="auth-box">
        <h1>Join JobsHotSpot 🚀</h1>
        <p>Create your account and find your dream job.</p>

        <form>
          <input type="text" placeholder="Full Name" required />
          <input type="email" placeholder="Email Address" required />

          <div className="password-wrapper">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Create a Password"
              required
            />
            <span
              className="toggle-password"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? "🙈" : "👁"}
            </span>
          </div>

          <button type="submit">Sign Up</button>
        </form>

        <p>
          {/* Already have an account? <a href="/login">Login here</a> */}
          Already have an account? <br/> <Link to="/login">Login here</Link>
        </p>
      </div>
    </div>
  );
};

export default Signup;
